
const FRIENDSEVENT_READY = "0";
const FRIENDSEVENT_STARTPLAY = "1";
const FRIENDSEVENT_DISCONNECT = "2";
const FRIENDSEVENT_ROOMCHANGE = "3";
const FRIENDSEVENT_NEWMESSAGE = "10";
const FRIENDSEVENT_NEWINVITATION = "11";
const FRIENDSEVENT_RELOADSTATE = "100";

const FLAG_INREQUEST = 1;
const FLAG_OUTREQUEST = 2;

const WGMODE_PLAY = "play";

jQuery(function($){

	var wgmode;

	var friendslist_rows = {};

	var transready = false;
	
	var uidself;
	
	var messages_page = 0;
	var messages_passscroll = false;
	var messages_loading = false;
	var messages_prevmsg;
	
	// if( !location.href.includes("test") && !location.href.includes("192") ) return;

	if( !$("#accountsettingsmenu").length ){
		
		return;
	}
	
	var containerhtml = `
<div id="friends-wg">
<div id="friends-header">
<div data-toggle="collapse" data-target="#friends-container" class="button button-friends"><i class="fas fa-user-friends fa-fw"></i><span id="friendswg-counter"></span></div>
<div id="friendsnotify-invitation" class="notifybutton secondary" style="display: none;"><i class="fas fa-share"></i><span></span></div><div id="friendsnotify-message" class="notifybutton secondary" style="display: none;"><i class="fas fa-envelope"></i><span></span></div><div id="friendsnotify-request" class="notifybutton" style="display: none;"><i class="fas fa-user-plus"></i><span>1</span></div>
<div class="button" id="friendswg-menubutton">
<div class="dropdown">
<i class="fas fa-caret-down fa-fw" data-toggle="dropdown"></i>
<div class="dropdown-menu dropdown-menu-right">
<a class="dropdown-item" href="#" data-tabname="friendlist"><span>Friends </span><span class="counter"></span> <span class="counter"></span></a>
<a class="dropdown-item" href="#" data-tabname="requests"><span>Requests </span><span class="counter"></span> <span class="counter"></span></a>
<a class="dropdown-item" href="#" data-tabname="settings">Settings</a>
<div class="dropdown-divider"></div>
<a class="dropdown-item" href="#" id="friendswg-menu-quit" title="Hold the shift key to set DND mode" data-exclbt >Close</a>
</div>
</div>
</div>
</div>
<div id="friends-container" class="collapse">

<div id="friends-tabfriendlist" class="tab">
<div class="header"><span>Friends</span>
<div id="friends-tabfriendlist-filterinput"><input type="text" class="form-control form-control-sm" maxlength="160"></div>
</div>
<div class="content"></div>
</div>
<div id="friends-tabrequests" class="tab" style="display: none;">
<div class="returnbutton"><i class="fas fa-arrow-circle-left"></i></div>
<div class="header"><span>Friend Requests</span></div>
<div class="content"></div>
</div>
<div id="friends-tabmessages" class="tab" style="display: none;">
<div class="returnbutton"><i class="fas fa-arrow-circle-left"></i></div>
<div class="header"><span>Messages</span></div>
<div class="content">
<div id="friends-tabmessages-header"></div>
<div id="friends-tabmessages-list"></div>
<div id="friends-tabmessages-input">
<div class="input-group input-group-sm">
  <input type="text" class="form-control" maxlength="200">
  <div class="input-group-append">
    <button class="btn btn-outline-secondary btn-light" type="button" id="friends-tabmessages-sendbutton"><i class="far fa-paper-plane"></i></button>
  </div>
</div>

</div>
</div>
</div>
<div id="friends-tabsettings" class="tab" style="display: none;">
<div class="returnbutton"><i class="fas fa-arrow-circle-left"></i></div>
<div class="header"><span>Settings</span></div>
<div class="content">
<label id="friends-settings-101"><a href="/friends/me" target="_blank">Friend list on your profile page</a>
<select class="custom-select custom-select-sm preference" data-key="101">
	<option value="0">Visible</option>
	<option value="1">Hidden</option>
</select>
</label>
<label id="friends-settings-102"><span>Notification sound</span>
<select class="custom-select custom-select-sm preference" data-key="102">
	<option value="0">-</option>
	<option value="1">1</option>
	<option value="2">2</option>
	<option value="3">3</option>
	<option value="4">4</option>
	<option value="5">5</option>
	<option value="6">6</option>
	<option value="7">7</option>
	<option value="8">8</option>
	<option value="9">9</option>
	<option value="10">10</option>
	<option value="11">11</option>
</select>
</label>
</div>
</div>
<div id="friends-tabdisconnected" class="tab"  style="display: none;">
<div class="header"><span></span></div>
<div class="content"><div class="descr">Disconnected from server</div></div>
</div>

<div class="dropdown rowmenu" id="tabfriendlist-rowmenu">
  <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" style="display: none;"></button>
  <div class="dropdown-menu dropdown-menu-right">
    <a class="dropdown-item disabled" href="#" id="tabfriendlist-rowmenu-joinroom">Join room</a>
	<div class="dropdown-divider"></div>
	<a class="dropdown-item" href="#" id="tabfriendlist-rowmenu-messages">Messages</a>
	<div class="dropdown-divider"></div>
	<a class="dropdown-item rowmenu-profile" href="#">Profile</a>
	<a class="dropdown-item rowmenu-gallery" href="#">Gallery</a>
	<div class="dropdown-divider"></div>
	<a class="dropdown-item" href="#" id="tabfriendlist-rowmenu-remove">Remove</a>
  </div>
</div>

<div class="dropdown rowmenu" id="tabrequests-rowmenu-in">
  <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" style="display: none;"></button>
  <div class="dropdown-menu dropdown-menu-right">
	<a class="dropdown-item" href="#" id="tabrequests-rowmenu-accept">Add to Friends</a>
	<a class="dropdown-item" href="#" id="tabrequests-rowmenu-reject">Reject</a>
	<div class="dropdown-divider"></div>
	<a class="dropdown-item rowmenu-profile" href="#">Profile</a>
	<a class="dropdown-item rowmenu-gallery" href="#">Gallery</a>
  </div>
</div>

<div class="dropdown rowmenu" id="tabrequests-rowmenu-out">
  <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" style="display: none;"></button>
  <div class="dropdown-menu dropdown-menu-right">	
	<a class="dropdown-item rowmenu-profile" href="#">Profile</a>
	<a class="dropdown-item rowmenu-gallery" href="#">Gallery</a>
	<div class="dropdown-divider"></div>
	<a class="dropdown-item" href="#" id="tabrequests-rowmenu-abort">Delete</a>
  </div>
</div>

<div class="dropdown rowmenu" id="tabmessages-rowmenu">
  <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" style="display: none;"></button>
  <div class="dropdown-menu dropdown-menu-right">
	<a class="dropdown-item disabled" href="#" id="tabmessages-rowmenu-roominvite">Invite</a>
	<div class="dropdown-divider"></div>
	<a class="dropdown-item rowmenu-profile" href="#">Profile</a>
	<a class="dropdown-item rowmenu-gallery" href="#">Gallery</a>
  </div>
</div>

</div>

</div>
		`;
	
	$('head').append('<link rel="stylesheet" href="/pageres/friends.css" type="text/css" />');
	$("body").append(containerhtml);
	
	setmode();
	
	if( !window.EventSource ){
		$("#friends-tabdisconnected .descr").text("Friends list not loaded: This browser does not support EventSource");
		showtab("disconnected", false);
		
		$("#friendswg-menubutton").hide();
		
		return;
	}
	
	var sse = new EventSource("/friendsapi/sseopen");
	
	sse.onerror = function(event){
		console.log("Friends list: connection error");
		
		showtab("disconnected", false);
		
		$("#friendswg-menubutton").hide();
		resetcounters();
		friendslist_rows = {};
	};
	
	sse.addEventListener(FRIENDSEVENT_READY, function(event){
		showtab("friendlist", false);
		$("#friendswg-menubutton").show();
		friendslist_fill(JSON.parse(event.data));
	});
	
	sse.addEventListener(FRIENDSEVENT_STARTPLAY, function(event){
		var [uid] = JSON.parse(event.data);
		
		if( !friendslist_rows[uid] ){
			console.error("friendslist_rows");
			
			return;
		}
		
		friendslist_rows[uid]
			.detach()
			.prependTo("#friends-tabfriendlist > .content")
			.addClass("inroom");

		$("#friendswg-counter").data("inroom", $("#friends-tabfriendlist > .content > .inroom").length);
		updatecounters();
	});
	
	sse.addEventListener(FRIENDSEVENT_DISCONNECT, function(event){
		var [uid] = JSON.parse(event.data);
		
		if( !friendslist_rows[uid] ){
			console.error("friendslist_rows");
			
			return;
		}
		
		friendslist_rows[uid]
			.detach()
			.appendTo("#friends-tabfriendlist > .content")
			.removeClass("inroom");

		$("#friendswg-counter").data("inroom", $("#friends-tabfriendlist > .content > .inroom").length);
		updatecounters();
	});
	
	sse.addEventListener(FRIENDSEVENT_RELOADSTATE, async function(event){
		friendslist_fill(await apirequest("getstate"));
	});
	
	sse.addEventListener(FRIENDSEVENT_NEWMESSAGE, async function(event){
		var [uid] = JSON.parse(event.data);
		
		if( $("#friends-tabmessages").is(":visible") && $("#friends-tabmessages").data("frienduid") == uid
			&& $("#friends-tabmessages-list").scrollTop() + $("#friends-tabmessages-list").height() >= $("#friends-tabmessages-list")[0].scrollHeight - 30 ){
			await loadmessages(friendslist_rows[uid], true);
		} else {
			notification_inc(friendslist_rows[uid], "newmessages");
			playsound("messagesound");
		}
	});
	
	sse.addEventListener(FRIENDSEVENT_NEWINVITATION, function(event){
		var [uid] = JSON.parse(event.data);
		
		var fromself = uid == uidself;
		
		if( !fromself && !ischatopen(uid) ){
			notification_inc(friendslist_rows[uid], "invitations");
		}
		
		if( fromself ){
			messages_addrow("#1#", new Date(), true, true);
		} else if( ischatopen(uid) ){
			messages_addrow("#1#", new Date(), false, true);
			loadmessages(friendslist_rows[uid], true);
		}
	});
	
	window.addEventListener('unload', function(event) {
		sse.close();
    });
	
	$("#friends-tabmessages-input input").keyup(function(event){
		if( $(this).is(":focus") && event.key == "Enter" ){
			$("#friends-tabmessages-sendbutton").click();
		}
	});
	
	$("#friends-tabmessages-list").scroll(function(event){
		if( messages_passscroll ){
			messages_passscroll = false;
			
			return;
		}
		
		if( $(this).scrollTop() + $(this).height() >= $(this)[0].scrollHeight ){
			loadmessages(friendslist_rows[$("#friends-tabmessages").data("frienduid")], true);
		} else if( $(this).scrollTop() < 1 ){
			loadmessages(friendslist_rows[$("#friends-tabmessages").data("frienduid")], false, true);
		}
	});
	
	$("#friends-tabfriendlist-filterinput input").keyup(function(event){
		if( $(this).is(":focus") && event.key == "Enter" ){
			$(this).blur();
		}
	});
	
	$("#friends-tabfriendlist-filterinput input").change(function(event){
		var str = $(this).val();
		
		if( !str ){
			for( var v of Object.values(friendslist_rows) ){
				v.show();
			}
			
			return;
		}
		
		for( var v of Object.values(friendslist_rows) ){
			if( v.find(".playername").text().includes(str) ){
				v.show();
			} else {
				v.hide();
			}
		}
	});
	
	var selffocus;
	$("#friends-wg").on("blur", function(event){
		selffocus = false;
		setTimeout(() => {
			if( !selffocus ){
				$("#friends-container").collapse("hide");
			}
		}, 100);
		
	});
	
	$("#friends-wg").on("focusout", function(event){
		if( event.target != this ){
			$("#friends-wg").focus();
		}
	});
	
	$("#friends-wg").on("focusin", function(event){
		selffocus = true;
	});
	
	$("#friends-wg").on("contextmenu", function(event){
		var el = $(event.target);
		if( el.closest("#friends-tabmessages-list").length || el.is("input") )
			return;
		
		event.stopPropagation();
		event.preventDefault();		
	});
	
	$("#friendsnotify-request").click(function(event){
		showtab("requests");
	});
	
	$("#friendsnotify-message").click(function(event){
		notification_scroll("newmessages");
	});
	
	$("#friendsnotify-invitation").click(function(event){
		notification_scroll("invitations");
	});
	
	$("#friends-container").on("show.bs.collapse", function(){
		$("#friends-wg")
			.addClass("friendswg-opened")
			.attr("tabindex", "-1")
			.focus();
			
		execcallback("wgshow", true);
		
	});
	
	$("#friends-container").on("shown.bs.collapse", function(){

		if( $("#friends-tabmessages").is(":visible") ){
			loadmessages(friendslist_rows[$("#friends-tabmessages").data("frienduid")], true);
		}
		
	});
	
	$("#friends-container").on("hidden.bs.collapse", function(){
		$("#friends-wg").removeClass("friendswg-opened");
		
		execcallback("wgshow", false);
	});
	
	$("#friendswg-menubutton > .dropdown").on("show.bs.dropdown", function () {
		// $("#friends-container").collapse("show");
	});
	
	$("#friendswg-menubutton .dropdown-item").click(function() {
		var str = $(this).data("tabname");
		if( str ){
			showtab(str);
		}
	});
	
	$("#friendswg-menu-quit").click(async function(event){
		if( event.shiftKey ){
			event.preventDefault();
			
			var dndstate = await apirequest("setdnd");
			
			if( dndstate != null ){
				alert(dndstate ? "DND enabled" : "DND disabled");
			}
			
			return;
		}
		
		sse.close();
		
		wgmode = null
		window.friendswg = null;
		$("#friends-wg").remove();
	})
	
	$("#friends-container > .tab > .header > span").click(function() {
		event.stopPropagation();
		$("#friendswg-menubutton [data-toggle='dropdown']").dropdown('toggle');
	});
	
	$("#friends-container .rowmenu").on("hide.bs.dropdown", function (event) {
		setTimeout(() => $(this).data("target").removeClass("menuopen"), 1);
	});
	
	$("#friends-tabfriendlist, #friends-tabmessages, #friends-tabrequests").on("click", "img", function(event){
		openplayerpage("profile", $(this).closest(".tabrow").data("playeruid"));
	});
	
	$("#friends-tabfriendlist").on("click", ".statustext", function(event){
		joinroom($(this).closest(".tabrow").data("playeruid"));
	});
	
	$("#friends-tabfriendlist").on("click", ".icon-newmessages", function(event){
		 $("#tabfriendlist-rowmenu").data("target", $(this).closest(".tabrow"));
		 $("#tabfriendlist-rowmenu-messages").click();
	});
	
	$("#friends-tabfriendlist").on("click", ".icon-invitations", function(event){
		joinroom($(this).closest(".tabrow").data("playeruid"), true);
	});
	
	$("#friends-tabrequests").on("click", ".incoming > .buttons > span", function(event){
		 $("#tabrequests-rowmenu-in").data("target", $(this).closest(".tabrow"));
		 if( $(this).index() == 0 ){
			$("#tabrequests-rowmenu-accept").click();
		 } else {
			$("#tabrequests-rowmenu-reject").click(); 
		 }
	});
	
	$("#friends-container > .tab .returnbutton, #tabmessages-rowmenu-return").click(function(event){
		showtab("friendlist");
	});
	
	$("#friends-container > .tab").on("click", ".tabrow", function(event){
		if( event.target == this ){
			event.stopPropagation();
			$(this).find(".menubutton").click()
		}
	});
	
	$("#friends-container > .tab").on("contextmenu", ".tabrow", function(event){
		event.stopPropagation();
		event.preventDefault();
		
		$(this).find(".menubutton").click();
	});
	
	$("#friends-container > .tab").on("click", ".menubutton", function(event){
		event.stopPropagation();
		
		var tabrow = $(this).closest(".tabrow");
		
		var tabid =  $(this).closest(".tab").attr("id");
		
		var menucontainer;
		if( tabid == "friends-tabfriendlist" ){
			menucontainer = $("#tabfriendlist-rowmenu");
		} else if( tabid == "friends-tabrequests" ){
			menucontainer = tabrow.hasClass("incoming") ? $("#tabrequests-rowmenu-in") : $("#tabrequests-rowmenu-out");
		} else if( tabid == "friends-tabmessages" ){
			menucontainer = $("#tabmessages-rowmenu");
		} else {
			
			return;
		}
		
		var el = menucontainer.find(".dropdown-toggle");
		el.dropdown('dispose');
		el.dropdown({"reference": this, "boundary": "window"});
		el.dropdown('toggle');

		if( menucontainer.data("target") ){
			menucontainer.data("target").removeClass("menuopen");
		}
		
		if( tabrow.hasClass("inroom") ){
			$("#tabfriendlist-rowmenu-joinroom").removeClass("disabled");
		} else {
			$("#tabfriendlist-rowmenu-joinroom").addClass("disabled");
		}
		
		tabrow.addClass("menuopen");
		menucontainer.data("target", $(tabrow));
	});
	
	$("#tabfriendlist-rowmenu-joinroom").on("click", function(event){
		joinroom($("#tabfriendlist-rowmenu").data("target").data("playeruid"));
	});
	
	$("#tabfriendlist-rowmenu-messages").on("click", async function(event){
		showtab("messages");
		
		$("#friends-tabmessages-sendbutton").addClass("disabled");
		
		setTimeout(() => $("#friends-tabmessages-input input").focus(), 1);
		
		await loadmessages($("#tabfriendlist-rowmenu").data("target"));

		$("#friends-tabmessages-sendbutton").removeClass("disabled");
	});
	
	$("#friends-wg .rowmenu-profile").on("click", function(event){
		openplayerpage("profile", $(this).closest(".rowmenu").data("target").data("playeruid"));
	});
	
	$("#friends-wg .rowmenu-gallery").on("click", function(event){
		openplayerpage("gallery", $(this).closest(".rowmenu").data("target").data("playeruid"));
	});
	
	$("#tabfriendlist-rowmenu-remove").on("click", function(event){
		apirequest("removefriend", {"uid": $("#tabfriendlist-rowmenu").data("target").data("playeruid")});
	});
	
	$("#tabrequests-rowmenu-accept").on("click", function(event){
		apirequest("friendrequest", {"uid": $("#tabrequests-rowmenu-in").data("target").data("playeruid"), "action": "inaccept"});
	});
	
	$("#tabrequests-rowmenu-reject").on("click", function(event){
		apirequest("friendrequest", {"uid": $("#tabrequests-rowmenu-in").data("target").data("playeruid"), "action": "inreject"});
	});
	
	$("#tabrequests-rowmenu-abort").on("click", function(event){
		apirequest("friendrequest", {"uid": $("#tabrequests-rowmenu-out").data("target").data("playeruid"), "action": "outabort"});
	});
	
	$("#friends-tabsettings .preference").change(function(event){
		var key = $(this).data("key");
		var val = $(this).val();
		
		if( key == 102 ){
			localstorage_set("messagesound", val);
			$("#messagesound").remove();
			playsound("messagesound");
		} else {
			setpref(key, val);
		}
	});
	
	$("#friends-tabmessages-sendbutton").click(async function(event){
		if( $(this).hasClass("disabled") ){
			
			return;
		}
		
		var message = $("#friends-tabmessages-input input").val();
		if( !message.length ){
			
			return;
		}
		
		if( chatfloodcheck($("#friends-tabmessages"), messages_prevmsg == message) ){
			alert(ln3("You are sending messages too fast", "CHATFLOODWARNING"));
			$("#friends-tabmessages-input input").val("");
			
			return;
		}
		
		messages_prevmsg = message;
		
		$("#friends-tabmessages-sendbutton").addClass("disabled");
		
		$("#friends-tabmessages-input input").val("");
		if( await apirequest("sendmessage", {"uid": $("#tabfriendlist-rowmenu").data("target").data("playeruid"), message}) ){
			messages_addrow(message, new Date(), true, true);
		}
		
		$("#friends-tabmessages-sendbutton").removeClass("disabled");
		
	});
	
	$("#tabmessages-rowmenu-roominvite").on("click", function(event){
		apirequest("sendinvitation", {"uid": $("#tabmessages-rowmenu").data("target").data("playeruid")});
	});
	
	$("#friends-tabmessages-list").on("click", ".emb", function(event){
		if( $(this).data("ts") > Date.now() - 24 * 3600 * 1000 && !$(this).closest(".message").hasClass("fromself") ){
			joinroom($("#friends-tabmessages").data("frienduid"), true);
		}
	});

	function friendslist_fill(state){
		if( !Array.isArray(state) ){
			
			throw "state";
		}
		
		var htmlstr = "";
		var [friendslist, friendsinroom, requests, notifications, uid] = state;
		
		uidself = uid;
		
		var messagescount = 0;
		var invitationcount = 0;
		
		friendsinroom.forEach((v) => {
			var [playername] = friendslist[v];
			
			if( notifications[v] ){
				var newmessages = notifications[v][0];
				var invitations = notifications[v][1];
				messagescount += newmessages;
				invitationcount += invitations;
				htmlstr += friendlist_getrowhtml(v, playername, "inroom", newmessages, invitations);
			} else {
				htmlstr += friendlist_getrowhtml(v, playername, "inroom", 0, 0);
			}
			
			delete friendslist[v];
		});
		
		for( var [k, v] of Object.entries(friendslist) ){
			var [playername] = v;
			
			if( notifications[k] ){
				var newmessages = notifications[k][0];
				var invitations = notifications[k][1];
				htmlstr += friendlist_getrowhtml(k, playername, "", newmessages, invitations);
				messagescount += newmessages;
				invitationcount += invitations;
			} else {
				htmlstr += friendlist_getrowhtml(k, playername, "", 0, 0);
			}
		}
		
		$("#friends-tabfriendlist > .content").html(htmlstr);
		
		friendslist_rows = {};
		$("#friends-tabfriendlist > .content > .tabrow").each(function(){
			var el = $(this);
			var uid = el.data("playeruid");
			friendslist_rows[uid] = el;
			if( notifications[uid] ){
				el.data("newmessages", notifications[uid][0]);
				el.data("invitations", notifications[uid][1]);
			} else {
				el.data("newmessages", 0);
				el.data("invitations", 0);
			}
		});
		
		var inrequestscount = 0;
		var outrequestscount = 0;
		htmlstr = "";
		requests.forEach((v) => {
			var [uid, playername, flag] = v;
			
			if( flag == FLAG_INREQUEST ){
				htmlstr += request_getrowhtml(uid, playername, "incoming");
				inrequestscount++;
			} else {
				htmlstr += request_getrowhtml(uid, playername);
				outrequestscount++;
			}
		});
		
		var el = $("#friendswg-counter");
		el.data("inroom", friendsinroom.length);
		el.data("total", Object.keys(friendslist).length);
		el.data("inrequests", inrequestscount);
		el.data("outrequests", outrequestscount);
		el.data("newmessages", messagescount);
		el.data("invitations", invitationcount);
		updatecounters();
		
		$("#friends-tabrequests > .content").html(htmlstr);
		
		if( $("#friends-tabmessages").is(":visible") && !friendslist_rows[$("#friends-tabmessages").data("frienduid")] ){
			showtab("friendlist", false);
		}
		
	}
	
	function tab_getrowhtml(uid, playername, addclass = "", addhtml = ""){
		return `
			<div class="tabrow ${addclass}" data-playeruid=${uid}>
			<img src="/avatar/cache/${uid}.jpg">
			<div class="menubutton"><i class="fas fa-ellipsis-v fa-fw"></i></div>
			<div class="playername">${playername}</div>
			${addhtml}
			</div>
		`
	}
	
	function friendlist_getrowhtml(uid, playername, addclass, newmessages, invitations){
		return tab_getrowhtml(uid, playername, addclass + (newmessages ? " newmessages" : "") + (invitations ? " invitations" : ""), `
			<div class="statustext"><span class="button">${ln3("In-room", "INROOM")}<span></div>
			<div class="notification icon-newmessages"><i class="fas fa-envelope fa-fw"></i><span>${newmessages}</span></div>
			<div class="notification icon-invitations"><i class="fas fa-share fa-fw"></i><span></span></div>
		`)
	}
	
	function request_getrowhtml(uid, playername, addclass){
		return tab_getrowhtml(uid, playername, addclass, `
			<div class="statustext"><span class="incoming">${ln3("Incoming", "INCOMING")}</span><span class="outgoing">${ln3("Outgoing", "OUTGOING")}</span></div>
			<div class="buttons"><span><i class="fas fa-check fa-fw"></i></span><span class="secondary"><i class="fas fa-times fa-fw"></i></span></div>
		`);
	}

	async function joinroom(uid, clearinvitation){
		var obj = await apirequest("getfriendroom", {uid, clearinvitation}, true);

		if( !obj || obj["error"] ){
			if( obj && (obj["error"] == "room" || obj["error"] == "friend") ){
				alert(ln3("Player not found in rooms", "JOINROOMERROR"))
			} else {
				alert(ln3("error", "ERROR"));
			}
			
			return;
		}
		
		var roomid = obj["res"];
		
		if( roomid == 1 ){
			alert(ln3("This player is now in a private room", "JOINROOMPRIVATE"));
				
			return;
		}
		
		if( roomid ){			
			if( wgmode != WGMODE_PLAY || confirm(ln3("Join room?", "ASKJOINROOM")) ){
				window.location = "/room/" + roomid;
			}
		}
	}
	
	async function addfriend(uid){
		var el = $(`#friends-tabrequests > .content > .tabrow[data-playeruid=${uid}]`);
		if( el.length ){
			showtab("requests");
			el[0].scrollIntoView({behavior: "smooth", block: "center"});
			setTimeout(() => el.find(".menubutton").click(), 500);
			
			return;
		}
		
		var obj = await apirequest("friendrequest", {"action": "outsend", uid}, true);
		
		if( !obj ){
			alert(ln3("error", "ERROR"));
		} else if( obj["res"] == "ok" ){
			alert(ln3("Friend request sent - they will appear in your Friends list once they have accepted your request", "REQUESTOK"));
		} else if( obj["error"] == "alreadyinlist" ){
			alert(ln3("Already friends", "REQUESTERROR1"));
		} else if( obj["error"] == "requestduplicate" ){
			alert(ln3("Request is pending", "REQUESTERROR2"));
		} else if( obj["error"] == "self" ){
			alert(ln3("You cannot add yourself as a friend", "REQUESTERROR3"));
		} else {
			alert(ln3("error", "ERROR"));
		}
		
	}
	
	function openplayerpage(page, uid){
		window.open(`/${page}/?uid=${uid}`, "_blank").focus();
	}
	
	function messages_addrow(message, created, fromself, scroll){
		$("#friends-tabmessages-list").append(`<div class="message ${fromself ? "fromself" : ""}"><div class="text">${replaceemb(message, created).replace(/https?:\/\/[^\s]*/g, '<a href="$&" target="_blank">$&</a>')}</div><div class="created">${formatdate(created)}</div></div>`);
		
		if( scroll ){
			messages_passscroll = true;
			$("#friends-tabmessages-list").scrollTop($("#friends-tabmessages-list")[0].scrollHeight);
		}
	}
	
	async function loadmessages(friendlistrow, onlynew, loadprev){
		if( !friendlistrow )
			return;
		
		if( messages_loading )
			return
		
		messages_loading = true;
		
		var uid = friendlistrow.data("playeruid");
		
		if( !onlynew && !loadprev ){
			messages_page = 0;
			$("#friends-tabmessages-list").empty();
			$("#friends-tabmessages-header").html(tab_getrowhtml(uid, friendlistrow.find(".playername").text()));
		}
		
		var arr = await apirequest("getmessages", onlynew ? {uid, onlynew} : {uid, "page": messages_page});
		if( !arr || !arr.length ){
			messages_loading = false;
			
			return;
		}
		
		if( !onlynew ){
			messages_page++;
		}
		
		var htmlstr = "";
		for( var i = arr.length - 1; i >= 0; i-- ){
			var [fromself, created, message] = arr[i];
			created = new Date(created * 1000);
			htmlstr += `<div class="message ${fromself ? "fromself" : ""}"><div class="text">${replaceemb(message, created).replace(/https?:\/\/[^\s]*/g, '<a href="$&" target="_blank">$&</a>')}</div><div class="created">${formatdate(created)}</div></div>`;
		}
		
		if( onlynew ){
			$("#friends-tabmessages-list").append(htmlstr);
		} else {
			var diff = $("#friends-tabmessages-list")[0].scrollHeight - $("#friends-tabmessages-list").scrollTop();
			$("#friends-tabmessages-list").prepend(htmlstr);
		}
		
		messages_passscroll = true;
		if( !loadprev ){
			$("#friends-tabmessages-list").scrollTop($("#friends-tabmessages-list")[0].scrollHeight);
		} else {
			$("#friends-tabmessages-list").scrollTop($("#friends-tabmessages-list")[0].scrollHeight - diff);
		}
		
		$("#friends-tabmessages").data("frienduid", uid);
		
		if( onlynew || messages_page == 1 ){
			notification_clear(friendlistrow, "newmessages");
			notification_clear(friendlistrow, "invitations");
		}
		
		messages_loading = false;
	}
	
	function notification_clear(friendlistrow, type){
		friendlistrow.removeClass(type);
		$("#friendswg-counter").data(type, $("#friendswg-counter").data(type) - friendlistrow.data(type));
		updatecounters();
		
		friendlistrow.data(type, 0);
	}
	
	function notification_inc(friendlistrow, type){
		friendlistrow.addClass(type);
		$("#friendswg-counter").data(type, $("#friendswg-counter").data(type) + 1);
		updatecounters();
		
		friendlistrow.data(type, friendlistrow.data(type) + 1);
		friendlistrow.find(".icon-newmessages > span").text(friendlistrow.data(type));
	}
	
	function notification_scroll(type){
		if( !$("#friends-tabfriendlist").is(":visible") ){
			showtab("friendlist");
			setTimeout(() => notification_scroll(type), 300);

			return;
		}
		
		for( var v of Object.values(friendslist_rows) ){
			if( v.data(type) ){
				v[0].scrollIntoView({behavior: "smooth", block: "center"});
				
				return;
			}
		}
	}
	
	function replaceemb(message, dateobj){
		if( message.charAt(0) == "#" ){
			var m = message.match(/^#(\d+)#$/);
			if( m ){
				var messagecode = m[1];
				if( messagecode == 1 ){
					message = `<a href=# class="emb" data-embtype="1" data-ts="${dateobj.getTime()}"><i class="fas fa-share fa-fw"></i></a>`;
				}
			}
		}
		
		return message;
	}
	
	function chatfloodcheck(el, strict){
		var triggered = false;
		
		if( !el ){
			
			return triggered;
		}
		
		var tm = el.data("floodtime") || 0;
		var counter = el.data("floodcounter") || 0;
		
		var timeout = Date.now() + (!strict ? 600 : 5000);
		
		if( tm > Date.now() ){
			if( counter >= (!strict ? 3 : 1) ){
				tm = Date.now() + 3000;
				
				triggered = true;
			} else {
				counter++;
				tm = timeout;
			}
		} else {
			if( counter > 0 ){
				counter--;
			}
			tm = timeout;
		}
		
		el.data("floodtime", tm);
		el.data("floodcounter", counter);
		
		return triggered;
	}
	
	function ischatvisible(uid){
		return $("#friends-tabmessages").is(":visible") && $("#friends-tabmessages").data("frienduid") == uid;
	}
	
	function ischatopen(uid){
		return $("#friends-tabmessages").css("display") != "none" && $("#friends-tabmessages").data("frienduid") == uid;
	}
	
	function tabchanged(tabname){
		if( tabname == "settings" ){
			$.getJSON(`/prefs/get`, {
				"key": "101"
			}, (obj) => {
				if( !obj || obj["error"] ){
					alert(ln3("error", "ERROR"));
				}
				
				$("#friends-tabsettings .preference[data-key=101]").val(obj["result"]);
				
				$("#friends-tabsettings .preference[data-key=102]").val(localstorage_get("messagesound") || "0");
			}, "json");
		} else if( tabname == "messages" ) {
			$("#friends-tabmessages").data("frienduid", "");
		}
	}
	
	function apirequest(method, params, returnraw){
		return new Promise(resolve => {
			$.post(`/friendsapi/${method}`, params, (obj) => {
				if( returnraw ){
					resolve(obj);
					
					return;
				}
				
				if( !obj || obj["error"] ){
					alert(obj ? obj["error"] : ln3("error", "ERROR"));
					resolve();
					
					return;
				}
				
				resolve(obj["res"]);
			}, "json");
		})
		
	}
	
	function execcallback(func, ...args){
		if( !window.friendscallback )
			return;
		
		window.friendscallback[func].apply(null, args);
		
	}
	
	function setpref(key, val){
		$.post(`/prefs/set`, {
			key,
			val
		}, (obj) => {
			if( !obj || obj["result"] != "ok" ){
				alert(ln3("error", "ERROR"));
			}
		}, "json");
	}
	
	function showtab(tabname, roll = true){
		if( roll && !$("#friends-container").is(":visible") ){
			$("#friends-container").collapse("show");
		}
		$("#friends-container > .tab").hide();
		$(`#friends-container > #friends-tab${tabname}`).show();
		
		tabchanged(tabname);
	}

	function updatecounters(){
		var el = $("#friendswg-counter");
		
		if( el.data("inroom") ){
			el.text(`${el.data("inroom")}`);
			$("#friendswg-menubutton [data-tabname=\"friendlist\"] > .counter:eq(1)").text(`${el.data("inroom")} `);
		} else {
			el.text("");
			$("#friendswg-menubutton [data-tabname=\"friendlist\"] > .counter:eq(1)").text("");
		}
		
		$("#friendswg-menubutton [data-tabname=\"friendlist\"] > .counter:eq(0)").text(`${el.data("total")}`);

		if( el.data("inrequests") ){
			$("#friendsnotify-request")
				.show()
				.find("span").text(el.data("inrequests"));
		} else {
			$("#friendsnotify-request").hide();
		}
		
		$("#friendswg-menubutton [data-tabname=\"requests\"] > .counter:eq(0)").text(el.data("inrequests") ? `${el.data("inrequests")}` : "");
		$("#friendswg-menubutton [data-tabname=\"requests\"] > .counter:eq(1)").text(el.data("outrequests") ? `${el.data("outrequests")}` : "");
		
		if( el.data("newmessages") ){
			$("#friendsnotify-message")
				.show()
				.find("span").text(el.data("newmessages"))
		} else {
			$("#friendsnotify-message").hide();
		}
		
		if( el.data("invitations") ){
			$("#friendsnotify-invitation")
				.show()
				.find("span").text(el.data("invitations"))
		} else {
			$("#friendsnotify-invitation").hide();
		}
	}
	
	function resetcounters(){
		$("#friendswg-counter").data({
			"inroom": 0,
			"inrequests": 0,
			"outrequests": 0,
			"newmessages": 0,
			"invitations": 0,
		});
		updatecounters();
	}
	
	function setmode(mode, position, privateroom){
		if( mode == "play" ){
			$("#friends-wg").removeClass("friendswg-homepage");
			
			$("#friends-wg").css("left", position - $("#friends-wg").width());
			
			if( !privateroom ){
				$("#tabmessages-rowmenu-roominvite").removeClass("disabled");
			}
		} else {
			$("#friends-wg").addClass("friendswg-homepage");
		}
		
		wgmode = mode;
	}
	
	function playsound(name){
		var el = $("#" + name);
		if( !el.length ){
			var id = localstorage_get(name);
			if( !id ){
				
				return;
			}
			el = $(`<audio style="display: none;" id="${name}" src="/snd/friends/${id}.mp3"></audio>`);
			$("body").append(el);
		}
		
		try {
			el[0].play()
				.catch((err) => {
					console.error(err);
				});
		} catch(err) {
			console.error(err);
		}
	}
	
	function formatdate(dateobj){
		return dateobj.toLocaleString([], {"dateStyle": "short", "timeStyle": "short"})
	}
	
	function localstorage_get(k){
		try {
			
			return localStorage.getItem(k);
			
		} catch(err) {
			console.error(err);
		}
	}
	
	function localstorage_set(k, v){
		try {
			
			localStorage.setItem(k, v);
			
			return true;
		} catch(err) {
			console.error(err);
			
			return false;
		}
	}
	
	
	window.friendswg = {
		setmode,
		showtab,
		"isfriend": (uid) => {
			return friendslist_rows[uid] != null;
		},
		"searchadd": (uid) => {
			if( sse.readyState != 1 ){
				
				return;
			}
			
			if( friendslist_rows[uid] ){
				showtab("friendlist");
				friendslist_rows[uid][0].scrollIntoView({behavior: "smooth", block: "center"});
				setTimeout(() => friendslist_rows[uid].find(".menubutton").click(), 500);
			} else {
				addfriend(uid);
			}
		}
	};
	
	try {
		translate();
	} catch (e) {}
	
	function translate(){
		if( trans == null )
			return;
		
		transready = true;
		
		if( trans.getselectedlang() == 1 )
			return;
		
		trans.transtempl["ERROR"] = ["Ошибка", "Error"];
		trans.transtempl["INROOM"] = ["В комнате", "En habitación"];
		trans.transtempl["INCOMING"] = ["Входящий", "Entrante"];
		trans.transtempl["OUTGOING"] = ["Исходящий", "Saliente"];
		trans.transtempl["ASKJOINROOM"] = ["Войти в комнату?", "Entra en la habitación?"];
		trans.transtempl["REQUESTOK"] = ["Запрос на добавление в друзья отправлен - друг появится в вашем списке, как только примет ваш запрос.", "Solicitud de amistad enviada: un amigo aparecerá en su lista una vez que haya aceptado su solicitud"];
		trans.transtempl["REQUESTERROR1"] = ["Уже в друзьях", "Ya en amigos"];
		trans.transtempl["REQUESTERROR2"] = ["Запрос ожидает рассмотрения", "La solicitud está pendiente"];
		trans.transtempl["REQUESTERROR3"] = ["Вы не можете добавить себя в друзья", "No puedes agregarte como amigo"];
		trans.transtempl["JOINROOMERROR"] = ["Игрок не найден в комнатах", "Jugador no encontrado en salas"];
		trans.transtempl["JOINROOMPRIVATE"] = ["Этот игрок сейчас в приватной комнате", "Este jugador está ahora en una habitación privada"];
		trans.transtempl["CHATFLOODWARNING"] = ["Слишком быстро отправляешь сообщения", "Estás enviando mensajes demasiado rápido"];
		
		trans.ts_text("#friendswg-menubutton .dropdown-item:eq(0) > span:eq(0)", "Друзья", "Amigos");
		trans.ts_text("#friendswg-menubutton .dropdown-item:eq(1) > span:eq(0)", "Запросы", "Solicitudes");
		trans.ts_text("#friendswg-menubutton .dropdown-item:eq(2)", "Настройки", "Configuraciones");
		trans.ts_text("#friendswg-menu-quit", "Закрыть", "Cerrar");
		trans.ts_text("#friends-tabfriendlist > .header > span", "Друзья", "Amigos");
		trans.ts_text("#friends-tabrequests > .header > span", "Запросы", "Solicitudes");
		trans.ts_text("#friends-tabsettings > .header > span", "Настройки", "Configuraciones");
		trans.ts_text("#friends-tabmessages > .header > span", "Сообщения", "Mensajes");
		trans.ts_text("#tabfriendlist-rowmenu-joinroom", "Войти в комнату", "Entra en la habitación");
		trans.ts_text("#tabfriendlist-rowmenu-messages", "Сообщения", "Mensajes");
		trans.ts_text("#tabfriendlist-rowmenu-remove", "Удалить", "Eliminar");
		trans.ts_text("#tabrequests-rowmenu-accept", "Принять", "Aceptar");
		trans.ts_text("#tabrequests-rowmenu-reject", "Отклонить", "Rechazar");
		trans.ts_text("#tabrequests-rowmenu-abort", "Снять", "Eliminar");
		trans.ts_text("#tabmessages-rowmenu-roominvite", "Пригласить в комнату", "Invitar a la sala");
		trans.ts_text("#friends-tabdisconnected > .content > .descr", "Нет соединения с сервером", "Desconectado del servidor");
		
		trans.ts_text("#tabfriendlist-rowmenu .rowmenu-profile", "Профиль", "Perfil");
		trans.ts_text("#tabfriendlist-rowmenu .rowmenu-gallery", "Галерея", "Galería");
		trans.ts_text("#tabrequests-rowmenu-in .rowmenu-profile", "Профиль", "Perfil");
		trans.ts_text("#tabrequests-rowmenu-in .rowmenu-gallery", "Галерея", "Galería");
		trans.ts_text("#tabrequests-rowmenu-out .rowmenu-profile", "Профиль", "Perfil");
		trans.ts_text("#tabrequests-rowmenu-out .rowmenu-gallery", "Галерея", "Galería");
		trans.ts_text("#tabmessages-rowmenu .rowmenu-profile", "Профиль", "Perfil");
		trans.ts_text("#tabmessages-rowmenu .rowmenu-gallery", "Галерея", "Galería");
		
		trans.ts_text("#friends-settings-101 > a", "Список друзей в вашем профиле", "Lista de amigos en tu página de perfil");
		trans.ts_text("#friends-settings-101 option:eq(0)", "Показывать", "Visible");
		trans.ts_text("#friends-settings-101 option:eq(1)", "Не показывать", "Oculta");
		trans.ts_text("#friends-settings-102 > span", "Звук уведомления", "Sonido de notificación");
		
	}
	
	function ln3(){
		if( !transready )
			return arguments[0];
		
		return trans.ln3.apply(null, arguments);
	}
	
});


	
	

